<template>
    <v-menu offset-y content-class="no-highlight">
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
                <v-icon>mdi-translate</v-icon>
            </v-btn>
        </template>
        <v-list dense>
            <v-list-item
                v-for="lang in languages"
                :key="lang.value"
                @click="setLocale(lang.value)"
                :class="{ 'v-list-item--active': $i18n.locale === lang.value }"
            >
                <v-list-item-title>{{ lang.label }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: "LanguageSwitcher",
    data() {
        return {
            languages: [
                { value: "en", label: "English" },
                { value: "ja", label: "日本語" },
            ],
        }
    },
    methods: {
        setLocale(locale) {
            this.$i18n.locale = locale
            localStorage.setItem("unsub-locale", locale)
        },
    },
}
</script>
